export const REFERRAL_LIST = 'REFERRAL_LIST';


